module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form-item', {
    attrs: {
      "label": "Tekst",
      "required": "",
      "error": _vm.errors[_vm.addLanguageSuffix('text')]
    }
  }, [_c('wyswig-input', {
    model: {
      value: (_vm.form[_vm.addLanguageSuffix('text')]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.addLanguageSuffix('text'), $$v)
      },
      expression: "form[addLanguageSuffix('text')]"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "slides"
  }, [_c('el-collapse', {
    staticClass: "formset__list"
  }, _vm._l((_vm.form.slides), function(slide, i) {
    return _c('div', {
      staticClass: "formset__item"
    }, [_c('el-collapse-item', {
      attrs: {
        "name": i
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('formset-header', {
      attrs: {
        "label": ("" + (slide.title_pl || 'Slajd')),
        "errors": _vm.checkForErrors(_vm.errors.slides, [i]),
        "items": _vm.form.slides,
        "index": i
      },
      on: {
        "update:items": function($event) {
          return _vm.$set(_vm.form, "slides", $event)
        }
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "inline-form-group"
    }, [_c('el-form-item', {
      attrs: {
        "label": "Zdjęcie",
        "error": _vm.errors.slides && _vm.errors.slides[i] && _vm.errors.slides[i]['photo']
      }
    }, [_c('image-input-component', {
      model: {
        value: (slide.photo),
        callback: function($$v) {
          _vm.$set(slide, "photo", $$v)
        },
        expression: "slide.photo"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Kolor tekstu",
        "error": _vm.errors.slides && _vm.errors.slides[i] && _vm.errors.slides[i]['text_color']
      }
    }, [_c('el-color-picker', {
      model: {
        value: (slide.text_color),
        callback: function($$v) {
          _vm.$set(slide, "text_color", $$v)
        },
        expression: "slide.text_color"
      }
    })], 1)], 1)], 2)], 1)
  }), 0), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.addSection
    }
  }, [_vm._v("Dodaj slajd")]), _vm._v(" "), (typeof _vm.errors.slides === 'string') ? _c('div', {
    staticClass: "el-form-item__error"
  }, [_vm._v("\n            " + _vm._s(_vm.errors.slides) + "\n        ")]) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f731aff"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/forms/PhotoWithTextWidget.vue
// module id = 732
// module chunks = 0